import React from "react";
import Image from "../../image/Image";
import Input from "../../ui/inputs/input/Input";
import { AppIcons } from "../../../data/appIcons";
import "../searchBar/SearchBar.scss";
import { Button } from "react-bootstrap";
import Label from "../label/Label";
import PropTypes from "prop-types";

function SearchBar(props) {
  return (

    <div className="search-section">
      <div className="search-part">
        {props.label ?
          <Label labelName={props.label} />
          : null
        }
        <Input
          type="text"
          name="search Value"
          value={props.searchText}
          placeholder={props.placeholder}
          onChange={props.onChange}
        />
        {props.isSearchIconVisible &&
          <div className="search-btn">
            <Button title="Search">
              <Image
                imagePath={AppIcons.searchIcon}
                imgCustomClassName="open-bar"
                altText="Icon"
              />
            </Button>
          </div>}
      </div>
    </div >
  );
}

SearchBar.propTypes = {
  label: PropTypes.string,
  searchText: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isSearchIconVisible: PropTypes.bool,
};

export default SearchBar;
